export default "__VITE_ASSET__BCH0m4KD__"